export default "<template>\r\n  <v-file-input label=\"File input\" outlined dense></v-file-input>\r\n</template>\r\n";